// extracted by mini-css-extract-plugin
export default {"qr_code_page":"QrCode_qr_code_page__jYoNy","content":"QrCode_content__1L-9Y","qr_code_container":"QrCode_qr_code_container__f9RaO"};